import { CookieKey } from '@/constants';
import { type ISessionData, LoginState } from '@/interfaces';
import { gtmSessions } from '@/utils';
import { getSessionData, setAndCheckNewSession } from '@/utils/cookies.utils';
import Cookies from 'js-cookie';
import { useMemo } from 'react';

export const useTrackSessions = (isLoggedIn: boolean) => {
  const loginState = useMemo(() => {
    const browserUuid = Cookies.get(CookieKey.BrowserUuid);
    if (!isLoggedIn && !!browserUuid) return LoginState.Unverified;
    if (!isLoggedIn) return LoginState.NotLoggedIn;
    return LoginState.Login;
  }, [isLoggedIn]);

  const triggerGtmSessions = (
    isMultiLanguagePage: boolean,
    pmtSessionData?: {
      emailSyncOptIn?: 'Yes' | 'No';
      numberOfEmailSyncAccounts?: number;
    },
  ) => {
    const handleSendSessionToGTM = (sessionsData: Array<ISessionData>) => {
      const isNewSession = setAndCheckNewSession(sessionsData);
      if (!isNewSession) return;
      const data = pmtSessionData ? { loginState, ...pmtSessionData } : { loginState };
      gtmSessions(data, isMultiLanguagePage);
    };
    getSessionData(isMultiLanguagePage, handleSendSessionToGTM);
  };

  return { triggerGtmSessions };
};
